'use client'

import RefereshButton from '@/components/RefereshButton'
import Image from 'next/image'
import Link from 'next/link'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className='min-h-screen h-full px-3 w-full flex items-center justify-center flex-col'>
      <div className=' w-11/12  md:w-11/12 h-fit'>
        <Image className=' mx-auto' src={`https://assets.bamboo.travel/404-error.svg`} alt='Error' width={600} height={600} />
      </div>
      <h1 className='font-semibold text-lg md:text-4xl mt-8 text-center'>Something went wrong!</h1>
      <p className=' md:text-xl text-gray-700 mt-2 text-center'>But don&apos;t worry, we&apos;re working day and night to fix this error. Hope you never meet this screen again.</p>
      <div className='mt-6 flex md:flex-row flex-col flex-wrap justify-center  w-full md:items-center gap-4'>
        <Link href={'/'} className='px-6 text-center py-3.5 text-gray-600 border border-gray-600 rounded-2xl'>
          back to the main page
        </Link>
        <button
          onClick={() => reset()}
          className='px-6 py-3.5 bg-primary text-white rounded-2xl'
        >
          Try again
        </button>
      </div>
    </div>
  )
}